import Swiper from '../imports/import-swiper';

export default () => {

  const sliderSwipeBig = document.querySelector('.slider_big');
  const sliderCardThree = document.querySelector('.slider_card');

  sliderSwipeBig?sliderHead():false;
  sliderCardThree?sliderCard():false;

  function sliderHead(){
      const bioTextSlidera = new Swiper(sliderSwipeBig , {
          slidesPerView: "auto",
          spaceBetween: 150,
          speed: 400,
          navigation: {
              prevEl: '.btn-slider_big_prev',
              nextEl: '.btn-slider_big_next',
          },
          breakpoints: {
            1500: {
              spaceBetween: 100,
            },
            1400: {
              spaceBetween: 60,
            },
            1199: {
              spaceBetween: 50,
            },
            1024: {
              spaceBetween: 65,
            },
            767: {
              spaceBetween: 10,
            }
          }
      });
  }

  function sliderCard(){
      const bioTextSlidera = new Swiper(sliderCardThree , {
          slidesPerView: 3,
          spaceBetween: 70,
          speed: 500,
          navigation: {
              prevEl: '.btn-slider_card_prev',
              nextEl: '.btn-slider_card_next',
          },
          breakpoints: {
            1500: {
              spaceBetween: 30,
            },
            1400: {
              spaceBetween: 20,
            },
            1199: {
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 36,
            },
            580: {
              slidesPerView: 1,
              spaceBetween: 10,
            }
          }
      });
  }

  document.querySelectorAll('.tab-body__box').forEach(n => {
    const slider = new Swiper(n.querySelector('.slider_post'), {
      loop: true,
      slidesPerView: 1,
      speed: 500,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      navigation: {
        nextEl: n.querySelector('.btn-slider_poster_next'),
        prevEl: n.querySelector('.btn-slider_poster_prev'),
      },
    });
  });

  const sliderTable = document.querySelector('.slider_table');

  sliderTable?sliderTables():false;

  function sliderTables(){
      const bioTextSlidera = new Swiper(sliderTable , {
          loop: true,
          slidesPerView: 7,
          speed: 500,
          navigation: {
              prevEl: '.btn-slider_sw_prev',
              nextEl: '.btn-slider_sw_next',
          },
          breakpoints: {
            1400: {
                slidesPerView: 6
            },
            1300: {
                slidesPerView: 5
            },
            1200: {
                slidesPerView: 4
            },
            767: {
                slidesPerView: 2
            },
            530: {
                slidesPerView: 1
            }
          }
      });
  }


    const sliderTwoCard = document.querySelector('.slider_card-two');

    sliderTwoCard?sliderCardHead():false;

    function sliderCardHead(){
        const bioTextSlidera = new Swiper(sliderTwoCard , {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 140,
            speed: 500,
            navigation: {
                prevEl: '.btn-slider_card-two_prev',
                nextEl: '.btn-slider_card-two_next',
            },
            breakpoints: {
            1200: {
                spaceBetween: 30,
            },
            1024: {
                spaceBetween: 75,
                slidesPerView: 1
            },
            767: {
                spaceBetween: 35,
                slidesPerView: 1
            }
            }

        });
    }


    //const sliderImageSection = document.querySelector('.slider_img');
    const sliderImageSection1 = document.getElementsByClassName('slider_img');
  

    //sliderImageSection?sliderImage():false;
    for (let i = 0; i < sliderImageSection1.length; i++) {
      sliderImage(sliderImageSection1[i]);
    }

    function sliderImage(item){
        const bioTextSlidera = new Swiper(item, {
            loop: true,
            slidesPerView: 1,
            speed: 300,
            navigation: {
                prevEl: '.btn-slider_image_prev',
                nextEl: '.btn-slider_image_next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }

    const sliderTestimonials = document.querySelector('.tm-slider');

    sliderTestimonials?sliderOrderImg():false;

    function sliderOrderImg(){
        const bioTextSlidera = new Swiper(sliderTestimonials , {
            slidesPerView: 1,
            speed: 300,
            cssMode: false,
            effect: 'fade',
            spaceBetween: 100,
            navigation: {
                prevEl: '.btn-slider_tm_prev',
                nextEl: '.btn-slider_tm_next',
            },
        });
    }

}
